enum PaymentGatewayProvider {
  Cashfree = 'Cashfree',
  BillDesk = 'BillDesk',
}

export default PaymentGatewayProvider;
